<template>
  <div class='page-wrapper'>
    <div class="top-box">
      <div class="logo-box"></div>
      <div class="logo-title">润生医荃宜互联网医院</div>
      <div class="page-title">满意度调查</div>
      <div class="doctor-box"></div>
      <div class="wire-box"></div>
      <div class="shallow-box"></div>
    </div>
    <div class="content-box">
      <div class="info-box">
        <div class="info-name">尊敬的先生/女士:</div>
        <div class="info-content">
          <div>您好！感谢您选择润生医荃宜互联网医院。为更好地提供医疗服务, 我们诚挚地邀请您针对本次就诊体验打分。 </div>
          <div>请根据您的真实感受，选择相应的调查结果，如您还有其他意见或建议，请填在最后的说明一栏内。 </div>
          <div>为保障您的权益，填写内容均予保密，敬请安心作答，您的宝贵意见是我们持续改进的基石，谢谢！</div>
        </div>
      </div>
      <div class="dashed-box"></div>
      <div class="form-box">
        <div class="form-item" v-for="(item, index) in itemOptions" :key="index">
          <div class="form-label"><span class="dot" v-if="item.required">*</span>{{ item.label }}</div>
          <div class="form-content">
            <template v-if="item.value === 'recommendIndex'">
              <div class="number-wrapper">

                <div class="number-box">
                  <div class="number-item" :class="i + 1 === form[item.value] ? 'number-item-active' : ''"
                    v-for="(it, i) in 10" :key="i" @click="!readonly && (form[item.value] = i + 1)">
                    {{ i + 1 }}
                  </div>
                </div>
                <div class="number-info">推荐指数: (数值越大表示推荐意愿越高)</div>
              </div>
            </template>
            <template v-else-if="item.value === 'proposal'">
              <div class="input-box">
                <van-field v-model="form.proposal" label="" show-word-limit type="textarea" autosize rows="2"
                  :maxlength="100" :disabled="readonly" placeholder="请输入...">
                </van-field>
              </div>
            </template>
            <template v-else>
              <div class="star-box">
                <div class="star-item" :class="i + 1 <= form[item.value] ? 'star-item-active' : ''" v-for="(it, i) in 5"
                  :key="i" @click="!readonly && (form[item.value] = i + 1)">
                </div>
              </div>
              <div class="content-title">{{ form[item.value] ? evaluateOptions[form[item.value] - 1].label : '' }}</div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="bottom-container">
        <van-button plain round @click="$router.back()">{{ readonly ? '返回' : '稍后评价' }}</van-button>
        <van-button type="primary" round :loading="loading" @click="onSubmit" v-if="!readonly">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateEvaluate, getEvaluateInfo } from '@/api/evaluate'
export default {
  name: 'evaluate-index',
  components: {},
  data() {
    return {
      evaluateOptions: [
        {
          label: '非常不满意',
          value: 1
        },
        {
          label: '不满意',
          value: 2
        },
        {
          label: '一般',
          value: 3
        },
        {
          label: '满意',
          value: 4
        },
        {
          label: '非常满意',
          value: 5
        }
      ],
      itemOptions: [
        {
          label: '您对润生医荃宜互联网医院的总体感受:',
          value: 'hospitalEval',
          required: true
        },
        {
          label: '您对医生服务的评价:',
          value: 'doctorEval',
          required: true
        },
        {
          label: '您对健康顾问服务的评价:',
          value: 'assistantEval',
          required: true
        },
        {
          label: '您对疗效的评价:',
          value: 'effectEval',
          required: true
        },
        {
          label: '您对整体操作流程便捷度的评价:',
          value: 'convenientEval',
          required: true
        },
        {
          label: '您对费用的评价:',
          value: 'costEval',
          required: true
        },
        {
          label: '您还会向其他人推荐润生医荃宜互联网医院吗?',
          value: 'recommendIndex',
          required: true
        },
        {
          label: '建议或意见:',
          value: 'proposal',
        }
      ],
      form: {
        hospitalEval: '',
        doctorEval: '',
        assistantEval: '',
        effectEval: '',
        convenientEval: '',
        costEval: '',
        recommendIndex: '',
        proposal: ''
      },
      loading: false,
      readonly: false,
      id: ''
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true
        this.itemOptions.forEach(item => {
          if (item.required && !this.form[item.value]) {
            this.$toast(`请选择${item.label}`)
            throw new Error('break')
          }
        })
        const params = {
          ...this.form,
          source: 2,
          status: 1,
          id: this.$route.query.id || this.id
        }
        await updateEvaluate(params)
        this.loading = false
        this.$toast('提交成功')
        this.$router.back()
      } catch (error) {
        this.loading = false
      }
    },
    async getEvaluateData() {
      try {
        const { data } = await getEvaluateInfo({ askNo: this.$route.query.askNo })
        if (data && data.status === 1) {
          this.readonly = true
          const {
            hospitalEval,
            doctorEval,
            assistantEval,
            effectEval,
            convenientEval,
            costEval,
            recommendIndex,
            proposal,
            id
          } = data
          this.form = {
            hospitalEval,
            doctorEval,
            assistantEval,
            effectEval,
            convenientEval,
            costEval,
            recommendIndex,
            proposal
          }
          this.id = id
        }

      } catch (error) {
        console.log(error)
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getEvaluateData()
  },
  activated() { }
}
</script>
<style lang='scss' scoped>
.page-wrapper {
  min-height: 100vh;
  background: #E7E9FF;
  padding-bottom: 18px;

  .top-box {
    width: 100%;
    height: 285px;
    background: linear-gradient(271deg, #6776FF 0%, #8894FF 100%);
    border-radius: 0px 0px 65px 0px;
    position: relative;
    padding-top: 15px;

    .logo-box {
      width: 207px;
      height: 32px;
      background: url('@/assets/images/evaluate/logo.png') no-repeat center/cover;
      margin: 0 0 0 18px;
    }

    .logo-title {
      font-size: 25px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 29px;
      padding-left: 22px;
      margin-top: 34px;
    }

    .page-title {
      font-size: 47px;
      color: #FFFFFF;
      letter-spacing: 5px;
      padding-left: 22px;
    }

    .doctor-box {
      position: absolute;
      width: 170px;
      height: 116px;
      bottom: 73px;
      right: 10px;
      background: url('@/assets/images/evaluate/doctor.png') no-repeat center/cover;
    }

    .wire-box {
      position: absolute;
      width: 445px;
      height: 21px;
      bottom: 52px;
      left: 50%;
      transform: translateX(-50%);
      background: url('@/assets/images/evaluate/wire.png') no-repeat center/cover;
    }

    .shallow-box {
      position: absolute;
      width: 435px;
      height: 46px;
      bottom: 21px;
      left: 50%;
      transform: translateX(-50%);
      background: url('@/assets/images/evaluate/shallow.png') no-repeat center/cover;
      z-index: 999;
    }

  }

  .content-box {
    position: relative;
    background: #fff;
    margin: 0 auto;
    margin-top: -50px;
    width: 426px;
    border-radius: 0 0 7px 7px;
    padding: 10px 18px 18px;
    box-sizing: border-box;

    .info-box {
      .info-name {
        font-size: 17px;
        font-weight: bold;
        color: #666666;
      }

      .info-content {
        margin-top: 4px;
        font-size: 17px;
        color: #666666;
        line-height: 20px;

        div {
          text-indent: 2em;
        }
      }
    }

    .dashed-box {
      width: 100%;
      position: relative;
      overflow: hidden;
      height: 32px;

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        top: 50%;
        left: 0;
        border-bottom: 1px dashed #C4C4C4;
        transform: translateY(-50%) scale(3, 0.3);
      }
    }

    .form-box {
      .form-item {
        &+.form-item {
          margin-top: 20px;
        }

        .form-label {
          position: relative;
          line-height: 20px;
          font-size: 17px;
          font-weight: bold;

          .dot {
            color: #F45430;
            margin-right: 5px;
          }
        }

        .form-content {
          display: flex;
          align-items: center;
          padding: 15px 0;

          .content-title {
            font-size: 17px;
            font-weight: bold;
            color: #313131;
          }

          .star-box {
            display: flex;

            .star-item {
              width: 36px;
              height: 36px;
              margin-right: 20px;

              background: url('@/assets/images/evaluate/item.png') no-repeat center/cover;
            }

            .star-item-active {
              background: url('@/assets/images/evaluate/item-active.png') no-repeat center/cover !important;
            }
          }

          .number-wrapper {
            flex: 1;

            .number-box {
              display: flex;
              justify-content: space-between;

              .number-item {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                border: 1px solid #C4C4C4;
                color: #C4C4C4;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .number-item-active {
                background: #5F6EF9;
                color: #fff;
              }
            }

            .number-info {
              font-size: 14px;
              color: #999999;
              margin-top: 12px;
            }
          }

          .input-box {
            border-radius: 5px;
            border: 1px solid #C4C4C4;
            flex: 1;
            overflow: hidden;

            :deep(.van-cell) {
              padding: 12px;

              .van-field__word-limit {
                color: #999999;
              }
            }
          }
        }
      }
    }
  }

  .bottom-box {
    height: 60px;

    .bottom-container {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 60px;
      background: #fff;
      padding: 14px 18px 0 18px;
      display: flex;
      box-sizing: border-box;

      :deep(.van-button) {
        height: 40px;
        color: #999999;
        flex: 1;

        &+.van-button {
          margin-left: 18px;
          flex: 2.5;
          background: #5F6EF9;
          color: #fff;
        }
      }
    }
  }
}
</style>